
import { TranslationsByLanguage } from './types';

export type DerivativesTranslationKey = 
  | 'derivatives.title'
  | 'derivatives.yourCreations'
  | 'derivatives.createNew'
  | 'derivatives.status.pending'
  | 'derivatives.status.approved'
  | 'derivatives.status.rejected'
  | 'derivatives.submittedOn'
  | 'derivatives.approvedOn'
  | 'derivatives.rejectedOn'
  | 'derivatives.basedOn'
  | 'derivatives.editFeatureSoon'
  | 'derivatives.deleted'
  | 'derivatives.deleteSuccess'
  | 'derivatives.playlist'
  | 'derivatives.allDerivatives'
  | 'derivatives.notFound'
  | 'derivatives.unknownCreator'
  | 'derivatives.loading'
  | 'derivatives.back'
  | 'derivatives.noVideoAvailable'
  | 'derivative.createdBy'
  | 'derivatives.sourceClips'
  | 'derivative.originalClip'
  | 'derivatives.noDerivatives'
  | 'derivatives.noDerivativesForFilter'
  | 'derivatives.viewDetails'
  | 'derivatives.description'
  | 'derivatives.frenchDescription'
  | 'derivatives.deleteConfirmTitle'
  | 'derivatives.deleteConfirmMessage'
  | 'derivatives.showMore'
  | 'derivatives.showLess'
  | 'derivatives.information'
  | 'derivatives.actions'
  | 'derivatives.comments'
  | 'derivatives.interactions'
  | 'derivatives.creator'
  | 'derivative.viewProfile'
  | 'derivatives.socialLinks'
  | 'derivatives.viewSources'
  | 'derivatives.viewSourceClips'
  | 'derivatives.playlistCreations'
  | 'derivatives.showing'
  | 'derivatives.of'
  | 'derivatives.items'
  | 'derivatives.allItemsLoaded';

export const derivativesTranslations: TranslationsByLanguage = {
  en: {
    'derivatives.title': 'Creations',
    'derivatives.yourCreations': 'Your Creations',
    'derivatives.createNew': 'Create New Derivative',
    'derivatives.status.pending': 'Pending',
    'derivatives.status.approved': 'Approved',
    'derivatives.status.rejected': 'Rejected',
    'derivatives.submittedOn': 'Submitted on',
    'derivatives.approvedOn': 'Approved on',
    'derivatives.rejectedOn': 'Rejected on',
    'derivatives.basedOn': 'Based on',
    'derivatives.editFeatureSoon': 'The ability to edit derivatives is coming soon.',
    'derivatives.deleted': 'Derivative Deleted',
    'derivatives.deleteSuccess': 'The derivative has been successfully deleted.',
    'derivatives.playlist': 'Playlist',
    'derivatives.allDerivatives': 'All Derivatives',
    'derivatives.notFound': 'Derivative not found',
    'derivatives.unknownCreator': 'Unknown Creator',
    'derivatives.loading': 'Loading derivative...',
    'derivatives.back': 'Back',
    'derivatives.noVideoAvailable': 'No video available',
    'derivative.createdBy': 'Created by',
    'derivatives.sourceClips': 'Source Clips',
    'derivative.originalClip': 'Original Clip',
    'derivatives.noDerivatives': 'No derivatives found',
    'derivatives.noDerivativesForFilter': 'No creations found with this expression type',
    'derivatives.viewDetails': 'View details',
    'derivatives.description': 'See how creators have transformed clips into new creative expressions.',
    'derivatives.frenchDescription': 'Découvrez comment les créateurs ont transformé les clips en nouvelles expressions créatives.',
    'derivatives.deleteConfirmTitle': 'Are you sure you want to delete this derivative?',
    'derivatives.deleteConfirmMessage': 'This action cannot be undone. The derivative will be permanently deleted from your account.',
    'derivatives.showMore': 'Show more',
    'derivatives.showLess': 'Show less',
    'derivatives.information': 'Information',
    'derivatives.actions': 'Actions',
    'derivatives.comments': 'Comments',
    'derivatives.interactions': 'Interactions',
    'derivatives.creator': 'Creator',
    'derivative.viewProfile': 'View profile',
    'derivatives.socialLinks': 'Social Links',
    'derivatives.viewSources': 'View sources',
    'derivatives.viewSourceClips': 'View source clips',
    'derivatives.playlistCreations': 'Playlist Creations',
    'derivatives.showing': 'Showing',
    'derivatives.of': 'of',
    'derivatives.items': 'items',
    'derivatives.allItemsLoaded': 'All items loaded'
  },
  fr: {
    'derivatives.title': 'Créations',
    'derivatives.yourCreations': 'Vos Créations',
    'derivatives.createNew': 'Créer un Nouveau Dérivé',
    'derivatives.status.pending': 'En attente',
    'derivatives.status.approved': 'Approuvé',
    'derivatives.status.rejected': 'Rejeté',
    'derivatives.submittedOn': 'Soumis le',
    'derivatives.approvedOn': 'Approuvé le',
    'derivatives.rejectedOn': 'Rejeté le',
    'derivatives.basedOn': 'Basé sur',
    'derivatives.editFeatureSoon': "La possibilité de modifier les dérivés sera bientôt disponible.",
    'derivatives.deleted': 'Dérivé Supprimé',
    'derivatives.deleteSuccess': 'Le dérivé a été supprimé avec succès.',
    'derivatives.playlist': 'Liste de lecture',
    'derivatives.allDerivatives': 'Tous les Dérivés',
    'derivatives.notFound': 'Dérivé introuvable',
    'derivatives.unknownCreator': 'Créateur Inconnu',
    'derivatives.loading': 'Chargement du dérivé...',
    'derivatives.back': 'Retour',
    'derivatives.noVideoAvailable': 'Aucune vidéo disponible',
    'derivative.createdBy': 'Créé par',
    'derivatives.sourceClips': 'Clips Sources',
    'derivative.originalClip': 'Clip Original',
    'derivatives.noDerivatives': 'Aucun dérivé trouvé',
    'derivatives.noDerivativesForFilter': 'Aucune création trouvée avec ce type d\'expression',
    'derivatives.viewDetails': 'Voir les détails',
    'derivatives.description': 'Découvrez comment les créateurs ont transformé les clips en nouvelles expressions créatives.',
    'derivatives.frenchDescription': 'Découvrez comment les créateurs ont transformé les clips en nouvelles expressions créatives.',
    'derivatives.deleteConfirmTitle': 'Êtes-vous sûr de vouloir supprimer ce dérivé ?',
    'derivatives.deleteConfirmMessage': 'Cette action ne peut pas être annulée. Le dérivé sera définitivement supprimé de votre compte.',
    'derivatives.showMore': 'Voir plus',
    'derivatives.showLess': 'Voir moins',
    'derivatives.information': 'Informations',
    'derivatives.actions': 'Actions',
    'derivatives.comments': 'Commentaires',
    'derivatives.interactions': 'Interactions',
    'derivatives.creator': 'Créateur',
    'derivative.viewProfile': 'Voir le profil',
    'derivatives.socialLinks': 'Réseaux Sociaux',
    'derivatives.viewSources': 'Voir les sources',
    'derivatives.viewSourceClips': 'Voir les clips sources',
    'derivatives.playlistCreations': 'Créations de la Playlist',
    'derivatives.showing': 'Affichage',
    'derivatives.of': 'sur',
    'derivatives.items': 'éléments',
    'derivatives.allItemsLoaded': 'Tous les éléments sont chargés'
  },
};
